<template>
    <div class="container-fluid">
      <div class="w-full rounded overflow-hidden shadow-lg">
          <!-- Contenedor principal para colocar ambas secciones en una fila -->
          <Loader :loading="isLoading" />
          <loader-component v-if="isLoading" :loading="isLoading" />
          <div class="flex flex-col">
            <div class="card w-full bg-white">
              <!-- Tabs Navigation -->
              <div class="card-tabs overflow-x-auto">
                <div class="flex border-b min-w-max">
                  <button 
                    @click="activeTab = 'general'" 
                    :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'general'}"
                    class="px-4 py-2 text-neutral-500 font-medium whitespace-nowrap"
                  >
                    General
                  </button>
                  <button 
                    @click="activeTab = 'social'" 
                    :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'social'}"
                    class="px-4 py-2 text-neutral-500 font-medium whitespace-nowrap"
                  >
                    Redes Sociales
                  </button>
                  <button 
                    @click="activeTab = 'propiedades'" 
                    :class="{'border-b-2 border-blue-500 text-blue-500': activeTab === 'propiedades'}"
                    class="px-4 py-2 text-neutral-500 font-medium whitespace-nowrap"
                  >
                    Propiedades
                  </button>
                </div>
              </div>
              <div v-if="activeTab === 'general'" class="w-full h-full rounded-lg">
                <!-- Sección de perfil a la izquierda -->
                <div class="flex flex-col lg:flex-row">
                  <!-- Sección de perfil -->
                  <div class="lg:w-1/3 p-4">
                    <div class="card-header text-left py-2">
                      <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                        Perfil
                      </div>
                    </div>
                    <div class="card-body pt-16">
                      <!-- Foto de perfil -->
                      <div class="user-image flex items-center justify-center mb-4">
                        <input type="file" id="profile_avatar" class="hidden" @change="updateProfileImage" />
                        <div class="avatar relative">
                          <img 
                            :src="imageSrc || defaultProfileImage" 
                            alt="Avatar" 
                            id="image_profile" 
                            class="rounded-full w-24 h-24 md:w-32 md:h-32 mx-auto mb-2" 
                          />
                        </div>
                      </div>
                      <div class="text-center">
                        <label class="text-neutral-500 text-lg md:text-xl font-medium font-['Poppins']">
                          <a 
                            :href="`${apiBaseUrl}/asesores-inmobiliarios/${slug}`" 
                            class="text-blue-500 hover:underline"
                            target="_blank" 
                            rel="noopener noreferrer">
                            {{ (name || '') + ' ' + (last_name || '') }}
                          </a>
                        </label>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Sección de información personal a la derecha -->
                  <div class="lg:w-2/3 p-4">
                    <div class="card-header text-left py-2">
                      <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                        Información Personal
                      </div>
                    </div>

                    <!-- Información personal -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div class="p-2">
                        <label class="text-style-sm mb-1">Nombre:</label>
                        <span class="w-full bg-white text-box block">{{ name }}</span>
                      </div>
                    <div class="p-2">
                      <label class="text-style-sm mb-1 block">Fecha de nacimiento:</label>
                      <span class="w-full bg-white text-box block">{{ birthday }}</span>
                    </div>
                            
                    <!-- Apellidos e ID -->
                    <div class="p-2">
  
                      <label class="text-style-sm mb-1 block">Apellido paterno:</label>
                      <span class="w-full bg-white text-box block">{{ last_name }}</span>
                    </div>
                    <div class="p-2">
                      <label class="text-style-sm mb-1 block">Apellido Materno:</label>
                      <span class="w-full bg-white text-box block">{{ last_second_name }}</span>
                    </div>

                    <!-- Email y Teléfono -->
                    <div class="p-2">
                      <label class="text-style-sm mb-1 block">Email:</label>
                      <span class="w-full bg-white text-box block break-words">{{ email }}</span>
                    </div>
                    <div class="p-2">
                      <label class="text-style-sm mb-1 block">Teléfono:</label>
                      <span class="w-full bg-white text-box block">{{ phone }}</span>
                    </div>
                      
                    <!-- Información de compañía, cargo, plan y tipo de cuenta -->
                    <div class="p-2">
                      <label class="text-style-sm mb-1 block">Compañía:</label>
                      <span class="w-full bg-white text-box block">
                        {{ companies.find(company => company.id === user.company_id)?.name || 'Sin compañía asignada' }}
                      </span>
                    </div>     
                    <div class="p-2">
                      <label class="text-style-sm mb-1 block">Cargo:</label>
                      <span class="w-full bg-white text-box block">
                        {{ cargos.find(cargo => cargo.id === user.position_id)?.name || 'Sin cargo asignado' }}
                      </span>
                    </div>
                    <div class="p-2">
                      <label class="text-style-sm mb-1 block">Plan:</label>
                      <span class="w-full bg-white text-box block">
                        {{ plans.find(plan => plan.id === user.plan_id)?.name || 'Sin plan asignado' }}
                      </span>
                    </div>
                    <div class="p-2">
                      <label class="text-style-sm mb-1 block">Tipo de Cuenta:</label>
                      <span class="w-full bg-white text-box block">
                        {{ accounts.find(account => account.id === user.account_id)?.name || 'Sin cuenta asignado' }}
                      </span>
                    </div>
                    <div class="p-2">
                      <label class="text-style-sm mb-1 block">Estatus:</label>
                      <span class="w-full bg-white text-box block"> {{ status }} </span>
                    </div>
                    <div class="p-2">
                      <button v-if="tokenAccess && tokenAccess !== ''" @click="activateAccount">
                        <span class="custom-secondary-btn">Activar Cuenta</span>
                      </button>
                    </div>
                    <div class="form-footer fixed bottom-0 left-0 right-0 bg-white p-4 md:relative md:mt-6 md:text-right md:p-0">
                      <div class="flex justify-end space-x-4">
                        <!-- Botón de Cancelar -->
                        <button type="button" @click="$router.push('/advisors')">
                          <span class="custom-secondary-btn">Cancelar</span>
                        </button>

                        <!-- Botón de Editar -->
                        <button @click="editUser(user.id)" class="custom-create-btn">
                          <span class="custom-create-btn-text">Editar Perfil</span>
                        </button>
                      </div>
                    </div>
                    <head>
                      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                    </head>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeTab === 'social'" class="p-4">
              <social-networks-form 
                :company-id="companyId" 
                @social-data-updated="handleSocialDataUpdate"
              ></social-networks-form>
            </div>
            <div v-if="activeTab === 'propiedades'" class="p-4">
              <Properties-list 
                :company-id="companyId" 
                @social-data-updated="handleSocialDataUpdate"
              ></Properties-list >
            </div>
          </div>
        </div>
      </div>
  </div> 
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import axios from "axios";
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import 'vue-toastification/dist/index.css';
import Loader from '@/components/loaderComponent.vue';
import defaultProfileImage from '@/assets/imgs/1.png';
import SocialNetworksForm from '@/components/advisor/NetworksAdvisorComponent.vue'; // Import the new component
import PropertiesList from '@/components/advisor/PropertiesAdvisorComponent.vue'; // Import the new component
import { useRouter } from "vue-router";

// Obtener la tienda de Vuex
const store = useStore();
const isLoading = ref(true); // Inicializamos isLoading
const activeTab = ref('general'); // Default active tab
const apiBaseUrl = computed(() => process.env.VUE_APP_API_BASE_URL.replace(/\/api$/, ""));
let session = computed(() => store.getters.getUserSession);
const route = useRoute();
let userId = computed(() => route.params.id);

let selectedRoles = ref([]);
// Variables reactivas
let name = ref(null);
let birthday = ref();
let email = ref();
let aboute_me = ref();
let phone = ref();
let  imageSrc = ref(null);
// Computed que devuelve la URL de la imagen a mostrar
let last_name = ref();
let status = ref();
let slug = ref();
let last_second_name = ref();
let profile = ref();
let companies = ref([]); // Declaración de companies
let user = ref({ company_id: null });
let roles = ref([]); // Declaración de roles
let cargos = ref([]); // Declaración de cargos
let plans = ref([]); // Declaración de planes
let accounts = ref([]); // Declaración de cuentas
let router = useRouter();
let tokenAccess = ref(""); // Nueva variable para el token

const handleSocialDataUpdate = (socialData) => {
      // You can add logic here to handle social data if needed
      console.log('Social data updated:', socialData);
  };
console.log(imageSrc)
// Obtener perfil
const translateStatus = (status) => {
  const statusTranslations = {
    active: 'Activo',
    delete: 'Desactivado',
    block: 'Bloqueado',
    pending: 'Pendiente',
    // Agrega más traducciones según sea necesario
  };

  return statusTranslations[status] || status; // Devuelve el estado original si no se encuentra traducción
};
async function getProfile() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };

    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${userId.value}`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    if (response.status === 200) {
      profile.value = response.data.resp.info;
      name.value = response.data.resp.info.name;
      last_name.value = response.data.resp.info.last_name;
      last_second_name.value = response.data.resp.info.last_second_name;
      email.value = response.data.resp.info.email;
      phone.value = response.data.resp.info.phone;
      slug.value = response.data.resp.info.slug;
      status.value = translateStatus(response.data.resp.info.status);
      aboute_me.value = response.data.resp.info.about_me;
      birthday.value = response.data.resp.info.birthday;
      user.value.company_id = response.data.resp.info.company_id; // Asigna el company_id
      user.value.plan_id = response.data.resp.info.plan_id; // Asigna el plan_id
      user.value.position_id = response.data.resp.info.position_id; // Asigna el position_id
      const profileAvatar = response.data.resp.info.profile_avatar;

      // Asigna la imagen de avatar
      if (profileAvatar) {
        imageSrc.value = `${profileAvatar}`;
      } else {
        imageSrc.value = null; // O un valor por defecto
      }
      console.log(imageSrc.value);
      tokenAccess.value = response.data.resp.info.token_access; // Guardar el token
      console.log("Token access:", tokenAccess.value); // Verificar el token
      // Extrae los IDs de los roles asociados y asígnalos a selectedRoles
      selectedRoles.value = response.data.resp.info.roles.map(role => role.id);
    }
    isLoading.value = false; 
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
async function editUser (id) {
  console.log("ID del usuario:", id); // Imprime el ID en la consola
  router.push({ name: 'AdvisorForm', params: { id } }); // Redirige a la ruta 'UserForm' con el ID del usuario
}
async function updateProfileImage(event) {
    const file = event.target.files[0];
    if (file) {
      // Similar al de portada, puedes cargar la imagen en tu servidor o mostrarla localmente
      const reader = new FileReader();
      reader.onload = () => {
        imageSrc.value = reader.result;   // Actualiza la imagen en la vista
        console.log(imageSrc)
      };
      reader.readAsDataURL(file);  // Convierte la imagen a base64
    }
  }
// Obtener compañías
async function fetchCompanies() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/companies`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    if (response.status === 200 && response.data?.resp?.companies) {
      companies.value = response.data.resp.companies; // Cambia esto
    } else {
      console.error("Error en la respuesta de la API: estructura inesperada");
    }
  } catch (error) {
    console.error("Error al obtener las compañías:", error);
  }
}

// Función para obtener roles
async function fetchRoles() { 
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/roles`, options);
    
    // Verifica si la respuesta es un error de autorización
    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    if (response.status === 200) {
      roles.value = response.data; // Asigna los roles correctamente
    }
  } catch (error) {
    console.error("Error al obtener los roles:", error);
  }
}

async function activateAccount() {
  if (!tokenAccess.value) {
    alert("No se encontró un token válido. Asegúrate de cargar el perfil primero.");
    return;
  }

  isLoading.value = true;

  try {
    const response = await axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/verify-account`,
      { token: tokenAccess.value }, // Enviar el token
      { headers: { 'Authorization': `Bearer ${session.value.token_api}` } }
    );

    if (response.status === 200 && response.data.status) {
      console.log("Cuenta activada con éxito:", response.data.message);
      alert("Cuenta activada correctamente");
      router.push({ name: "Dashboard" }); // Redirige al dashboard o a otra vista
    }
  } catch (error) {
    console.error("Error al activar la cuenta:", error);
    if (error.response) {
      alert(error.response.data.message || "Error al activar la cuenta");
    }
  } finally {
    isLoading.value = false;
  }
}
//obtener los cargos
async function fetchCargos() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/cargos`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    // Accede a los cargos en response.data.cargos
    if (response.status === 200 && response.data?.cargos) {
      cargos.value = response.data.cargos; 
    } else {
      console.error("Error en la respuesta de la API: estructura inesperada");
    }
  } catch (error) {
    console.error("Error al obtener los cargos:", error);
  }
}

//obtener los cargos
async function fetchPlanes() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/planes`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    // Accede a los cargos en response.data.cargos
    if (response.status === 200 && response.data?.plans) {
      plans.value = response.data.plans; 
    } else {
      console.error("Error en la respuesta de la API: estructura inesperada");
    }
  } catch (error) {
    console.error("Error al obtener los planes:", error);
  }
}

//obtener los cargos
async function fetchAccounts() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/account`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    // Accede a los cargos en response.data.cargos
    if (response.status === 200 && response.data?.accounts) {
      accounts.value = response.data.accounts; 
    } else {
      console.error("Error en la respuesta de la API: estructura inesperada");
    }
  } catch (error) {
    console.error("Error al obtener los planes:", error);
  }
}

// Llama a la función para obtener los roles al montar el componente
onMounted(async () => {
  await fetchCompanies();
  await fetchRoles();
  await fetchCargos();
  await fetchPlanes();
  await fetchAccounts();
  await getProfile();  // Asegúrate de obtener el perfil después de las compañías
});


// Computed properties
//const isRoleAdminOrManager = computed(() => {
//  return session.value && (session.value.role === 'admin' || session.value.role === 'manager');
//});


</script>


<style scoped>
  /* Label personalizado */
  ::v-deep .custom-label label,
  ::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
    @apply text-white;
  }

  /* Fondo del body */
  body {
    background-color: #ffffff !important;
  }

  /* Imagen de usuario */
  .user-image {
    position: relative;
    margin-top: -60px;
    margin-bottom: 1rem;
  }
  .avatar {
    @apply rounded-full border-4 border-white inline-block overflow-hidden;
  }

  .text-box {
      @apply p-2 rounded border border-gray-200;
  }

  .text-style-sm {
      @apply text-sm text-gray-600 font-medium;
  }

  /* Estilos responsivos adicionales */
  @media (max-width: 768px) {
      .card-tabs {
          @apply sticky top-0 bg-white z-10;
      }
      
      .user-image {
          margin-top: -40px;
      }
  }

  /* Roles en contenedor flexible */
  .roles-container {
    @apply flex flex-wrap gap-4;
  }

  /* Checkbox seleccionado */
  .form-check-input:checked {
    @apply bg-pink-500 border-pink-500;
  }
</style>
